import Vue from 'vue'
import Router from 'vue-router'
import Layout from './views/Layout.vue'
import Map from './views/MapDashboard.vue'
import store from './store'
import { LoginRoutes, ParantionEventBus } from '@parantion/components'
import { setHeaders } from './services/APIService.js'
import { Notify } from 'quasar'
// @ts-ignore
import packageJson from '../package.json'
// @ts-ignore
import logo from './assets/logo.svg'
// @ts-ignore
import background from './assets/low_poly.jpg'

Vue.use(Router)

const router = new Router({
  // mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'layout',
      redirect: '/home',
      meta: {
        requiresAuth: true
      },
      component: Layout,
      children: [
        {
          path: '/home',
          name: 'home',
          component: Map
        },
        {
          path: '/about',
          name: 'about',
          // route level code-splitting
          // this generates a separate chunk (about.[hash].js) for this route
          // which is lazy-loaded when the route is visited.
          component: () => import(/* webpackChunkName: "about" */ './views/About.vue')
        },
        {
          path: '/results',
          name: 'results',
          component: () => import('./views/Results.vue')
        },
        {
          path: '/tasks',
          name: 'tasks',
          component: () => import('./views/Tasks.vue')
        }
      ]
    },
    {
      path: '/mapDemo',
      name: 'mapDemo',
      props: true,
      component: () => import('./views/MapDashboard.vue')
    },
    LoginRoutes({
      logo,
      backgroundImage: background,
      version: packageJson.version,
      emailSubject: 'Wachtwoord persoonlijke inlogpagina instellen',
      emailTheme: 'pip',
      tenantName: packageJson.name,
      passwordForgetConfig: { email: 'pip' },
      usePipConfig: true,
      onLogin: user => {
        onLogin()
        if (isPanelUser(user.role)) {
          store.dispatch('directus/retrieveConfig', {
            oid: user.authenticate.oid,
            org: router.currentRoute.params.organisation
          }).then(() => {
            screen.width > 767 ? router.push('/home') : router.push('/tasks')
          })
        } else {
          Notify.create({
            message: 'Sorry, u heeft de verkeerde rechten. | Sorry, you have insufficient rights',
            icon: 'sentiment_very_dissatisfied',
            textColor: 'black',
            color: 'red-11'
          })
          logOut()
        }
      },
      onLogout: user => {
        sessionStorage.removeItem(packageJson.name + '-vx')
        if (store.state['directus'].org) {
          router.push(`/login/panel/${store.state['directus'].org}`)
        } else {
          router.push('login')
        }
        store.commit('tasks/RESET')
        store.commit('directus/RESET')
      }
    }, this)
  ]
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth) && !checkAuthentication()) {
    next('/login')
  } else {
    next()
  }
})

function isPanelUser(roles) {
  return roles.includes('panel_user')
}

function checkAuthentication() {
  const correctRole = store.state['parantion'].user.roles.includes('panel_user')
  const state: any = store.state
  const isLoggedIn = correctRole && state.parantion.user.user && state.parantion.user.token
  if (isLoggedIn) {
    setHeaders(state.parantion.user.token, state.parantion.user.database)
  }
  return isLoggedIn
}

function logOut() {
  sessionStorage.removeItem(packageJson.name + '-vx')
}

function onLogin () {
  ParantionEventBus.on('logout', () => {
    logOut()
  })
}

export default router
